import { Inject } from '@odinjs/odin';

import { catchRenderException } from '@philips-emr/hpms-components';
import { ButtonAPI, FormAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnValidate } from '@philips-emr/tws-core/lib/client';
import { ClickEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { format } from '@philips-emr/tws-core/lib/services/model-service';

import { FragmentNames, ModalExtratoUtilizacaoAliases } from '../../codegen';
import { Report, ReportService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_EXTRATO_UTILIZACAO })
export default class ModalExtratoUtilizacaoController extends BaseController {

  @Inject(ModalExtratoUtilizacaoAliases.FORM)
  private form: FormAPI;
  @Inject(ModalExtratoUtilizacaoAliases.BUTTON_GERAR)
  private buttonGerar: ButtonAPI;

  @OnValidate(ModalExtratoUtilizacaoAliases.FORM)
  onValidate = ({ valid }: ValidateEvent): void => this.buttonGerar.setEnabled(valid);

  @OnClick(ModalExtratoUtilizacaoAliases.BUTTON_GERAR)
  onClick({ target }: ClickEvent): void {
    this.form.submit();
    if (this.form.isValid()) {

      const api = target as ButtonAPI;
      const { record, cdGrupo, nrSeqBeneficiario } = this.context.getBulkData();
      const { dtInicial, dtFinal } = this.form.getRecord();

      const data = {
        DT_INICIO: format('date', dtInicial),
        DT_FIM: format('date', dtFinal),
      };

      api.setState({ loading: true });
      ReportService.openReport({
        nrSeqBeneficiario: nrSeqBeneficiario as number,
        cdGrupo: cdGrupo as string,
        parametrosRelatorio: data,
        record: record as Report[],
      })
        .finally(() => catchRenderException(() => api.setState({ loading: false })));
    }
  }

}
